export const ACTIVITY_TYPES = ['note', 'call', 'email'];

export const ACTIVITY_ICONS = {
  note: 'far fa-sticky-note',
  call: 'fas fa-phone',
  email: 'far fa-envelope',
  meeting: 'far fa-calendar-alt',
  status_change: 'fas fa-exchange-alt',
  system: 'fas fa-cog',
};

export const ACTIVITY_TYPE_LABELS = {
  note: 'leads.activityType.note',
  call: 'leads.activityType.call',
  email: 'leads.activityType.email',
  meeting: 'leads.activityType.meeting',
  status_change: 'leads.activityType.status_change',
  system: 'leads.activityType.system',
};
